import { messagingRequestsTyped } from "@/api/(requests)/messagingTyped";

export async function getUnreadMessageCount(): Promise<number> {
  const response = await messagingRequestsTyped.fetch_unread_message_count();

  return response.unread_count;
}
